module.exports = __webpack_public_path__ + "static/media/GolfBuggy.32008ace.png";